import React from 'react';
import { SunIcon } from 'lucide-react';
export function ThemeToggle() {
  return <button className="p-2 rounded-full hover:bg-[#F5F7FA] hover:bg-opacity-10 transition-colors" data-id="element-803">
      <SunIcon className="h-5 w-5 text-[#F5F7FA]" data-id="element-804" />
    </button>;
}